// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"top-photos-module--sliderContainer--12-eg","textBox":"top-photos-module--textBox--2Dk6Z"};